import {Button} from '@mantine/core';
import {useCallback, useEffect} from 'react';
import {
    useClearActiveEdit,
    useIsLinkCreationActive,
    useStartLinkCreation,
} from '../state/networkEditStore';

export function LinkCreationButton() {
    const startLinkCreation = useStartLinkCreation();
    const isActive = useIsLinkCreationActive();
    const clearLinkCreation = useClearActiveEdit();

    const handleClick = useCallback(() => {
        startLinkCreation();
    }, [startLinkCreation]);

    // ESC key cancels the current flow (mirrors previous AddLinkButton behaviour)
    useEffect(() => {
        const onKeyDown = (e: KeyboardEvent) => {
            if (e.key === 'Escape' && isActive) {
                clearLinkCreation();
            }
        };
        window.addEventListener('keydown', onKeyDown);
        return () => window.removeEventListener('keydown', onKeyDown);
    }, [isActive, clearLinkCreation]);

    return (
        <Button
            data-testid="linkCreationButton"
            style={{pointerEvents: 'all'}}
            disabled={isActive}
            onClick={handleClick}
        >
            Add Rope
        </Button>
    );
}
